'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import axios from 'axios';

export default function FirstVisitAttribution() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const attributionParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'fbclid',
      'msclkid',
    ];

    const arrAttributionParams: Record<string, string> = {};

    attributionParams.forEach((param) => {
      const value = searchParams.get(param);
      if (value) {
        arrAttributionParams[param] = value;
      }
    });

    if (Object.keys(arrAttributionParams).length > 0) {
      void axios
        .post(
          `${process.env.NEXT_PUBLIC_ATTRIBUTION_API_URL ?? ''}/SUGboxAPI.cfm?go=c.captureMemberAttribution`,
          {
            attributionparams: arrAttributionParams,
          },
          {
            withCredentials: true, // This sends HTTP-only cookies
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .catch((error) => {
          console.error('Failed to capture attribution:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

// 'use client';

// import { useEffect } from 'react';
// import { useSearchParams } from 'next/navigation';
// import axios from 'axios';

// export default function FirstVisitAttribution() {
//   const searchParams = useSearchParams();

//   useEffect(() => {
//     const attributionParams = [
//       'utm_source',
//       'utm_medium',
//       'utm_campaign',
//       'utm_term',
//       'utm_content',
//       'gclid',
//       'fbclid',
//       'msclkid',
//     ];

//     const arrAttributionParams: Record<string, string> = {};

//     attributionParams.forEach((param) => {
//       const value = searchParams.get(param);
//       if (value) {
//         arrAttributionParams[param] = value;
//       }
//     });

//     if (Object.keys(arrAttributionParams).length > 0) {
//       void axios
//         .post('/api/attribution', {
//           attributionParams: arrAttributionParams,
//         })
//         .catch((error) => {
//           console.error('Failed to capture attribution:', error);
//         });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return null;
// }
